import { render, staticRenderFns } from "./PdfTable.vue?vue&type=template&id=0021a6e9&scoped=true"
import script from "./PdfTable.vue?vue&type=script&lang=js"
export * from "./PdfTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0021a6e9",
  null
  
)

export default component.exports